import i18n from "@/locale/i18n";
import _ from "lodash-es";
import config from "./config";
import { useMemberStore, useMetaStore } from "@/stores";
import dayjs from "dayjs";
import TileLayer from "ol/layer/Tile";
import { XYZ } from "ol/source";
import { TileGrid } from "ol/tilegrid";
import { Projection } from "ol/proj";
import proj4 from "proj4";
import { register } from "ol/proj/proj4";
import { useRouter } from "vue-router";
import { th } from "vuetify/locale";
const { t } = i18n.global;
export const toArr = (arrLike) => {
  const arr = [];
  for (let i = 0; i < arrLike.length; i++) arr.push(arrLike[i]);
  return arr;
};
export const numArr = (start, end) => {
  let result = [];
  for (let i = start; i <= end; i++) {
    result.push(i);
  }
  return result;
};
export const twoDemArr = (arr, size) => {
  let result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};
export const collectNum = (str) => {
  return str.match(/\d+/g).map(Number);
};
export const validators = {
  email: (v) =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) ||
    t("emailnotvalid"),
  required: (v) => !!v || t("pleaseconfirmtheinformationyouentered"),
  retypeBefore: (pv, v, tkey) => pv == v || t(tkey),
  min8letters: (v) => v.length >= 8 || t("lettermin8"),
  engbigsmallnummintwo: (v) =>
    /^(?=(.*[a-zA-Z]))(?=(.*\d))|(?=(.*[a-zA-Z]))(?=(.*[^\w\s]))|(?=(.*\d))(?=(.*[^\w\s]))/.test(
      v,
    ) || t("at_least_two_of_the_following"),
  isValidUrl: (v) =>
    /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(v) || t("wrong_url"),
};
export const isValidPassword = (pw) => {
  if (!pw) return "비밀번호를 입력해 주세요.";
  // 조건 1: 최소 8자
  if (pw.length < 8) {
    return "비밀번호는 최소 8자 이상이어야 합니다.";
  }

  // 조건 2: 영문 대/소문자, 숫자, 특수문자 중 2종류 이상
  const types = [
    /[a-z]/, // 소문자
    /[A-Z]/, // 대문자
    /[0-9]/, // 숫자
    /[^a-zA-Z0-9]/, // 특수문자
  ];
  let typeCount = types.filter((regex) => regex.test(pw)).length;
  if (typeCount < 2) {
    return "영문 대/소문자, 숫자, 특수문자 중 2가지 이상을 포함해야 합니다.";
  }

  // 조건 3: 동일한 문자 4회 이상 반복 금지
  if (/(.)\1{3,}/.test(pw)) {
    return "동일한 문자를 4번 이상 연속으로 사용할 수 없습니다.";
  }

  // 조건 4: 연속 숫자 4자 이상 (1234, 4321 등)
  const digitsOnly = pw.replace(/[^0-9]/g, "");
  for (let i = 0; i <= digitsOnly.length - 4; i++) {
    const slice = digitsOnly
      .slice(i, i + 4)
      .split("")
      .map(Number);
    if (
      slice.every((v, idx, arr) => idx === 0 || arr[idx - 1] + 1 === v) || // 오름차순
      slice.every((v, idx, arr) => idx === 0 || arr[idx - 1] - 1 === v) // 내림차순
    ) {
      return "연속된 숫자를 4자리 이상 사용할 수 없습니다.";
    }
  }

  // 조건 5: 키보드 상 연속 문자 3자 이상 사용 금지
  const keyboardLines = [
    "qwertyuiop",
    "asdfghjkl",
    "zxcvbnm",
    "QWERTYUIOP",
    "ASDFGHJKL",
    "ZXCVBNM",
  ];
  for (let line of keyboardLines) {
    for (let i = 0; i <= line.length - 3; i++) {
      const seq = line.substring(i, i + 3);
      if (pw.includes(seq)) {
        return "키보드 상에서 연속된 문자(예: qwe, asd)를 3자 이상 사용할 수 없습니다.";
      }
    }
  }

  // 조건 6: 공백(스페이스) 사용 금지
  if (/\s/.test(pw)) {
    return "공백 문자는 사용할 수 없습니다.";
  }

  return true;
};
export const authPageType = (path) => {
  const paths = path
    .split("?")[0]
    .split("/")
    .filter((p) => !_.isEmpty(p))
    .map((pp) => pp.toLowerCase());
  if (paths.length <= 1) return "noauth";
  return path[0];
};
export const formatNumber = (value, decimals = 2) =>
  Number(value)
    .toFixed(decimals)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
export const formatDaySec = (dtstr) =>
  dtstr ? dayjs(dtstr).format("YYYY-MM-DD HH:mm:ss") : null;
export const formatDayMin = (dtstr) =>
  dtstr ? dayjs(dtstr).format("YYYY-MM-DD HH:mm") : null;
export const formatDay = (dtstr) =>
  dtstr ? dayjs(dtstr).format("YYYY-MM-DD") : null;
export const entries = (obj) =>
  _.entries(obj).map((ent) => ({ key: ent[0], value: ent[1] }));
export const serverLog = (
  logstatus,
  logtype,
  logdata,
  callback = () => {},
  onerr = () => {},
) => {
  logdata.logstatus = logstatus;
  logdata.logtype = logtype;
  if (_.isObject(logdata.pval)) logdata.pval = JSON.stringify(logdata.pval);
  if (_.isObject(logdata.nval)) logdata.nval = JSON.stringify(logdata.nval);
  return post("rest/authed/admin/addlog", logdata, callback, onerr);
};
export const maskStr = (str, nth) => {
  if (_.isEmpty(str)) return "";
  if (!nth) nth = 3;
  if (str.length <= nth) return str;
  const firstThree = str.slice(0, nth);
  const maskedPart = "*".repeat(str.length - nth);
  return firstThree + maskedPart;
};
export const degToRad = (degrees) => {
  return (degrees * Math.PI) / 180;
};
export const degToRadClockwise = (degrees) => {
  return (2 * Math.PI - degToRad(degrees)) % (2 * Math.PI);
};
export const formatBytes = (bytes, unit, tostr) => {
  if (bytes === 0) return "0 Bytes";
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  let i = 0;
  if (unit) {
    i = sizes.indexOf(unit);
    if (i === -1) {
      throw new Error("Invalid unit provided");
    }
  } else {
    i = Math.floor(Math.log(bytes) / Math.log(1024));
  }
  const rslt = parseFloat((bytes / Math.pow(1024, i)).toFixed(2));
  if (!unit) {
    if (!tostr) return [rslt, sizes[i]];
    return rslt + sizes[i];
  }
  return rslt;
};
export const uuid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
export const getFileName = (filePath) => {
  return filePath.split(/[/\\]/).pop();
};
export const ymd = (dt) => {
  if (!dt) return "";
  return dayjs(dt).format("YYYY-MM-DD");
};
export const ymdhm = (dt) => {
  if (!dt) return "";
  return dayjs(dt).format("YYYY-MM-DD HH:mm");
};
export const ymdhms = (dt) => {
  if (!dt) return "";
  return dayjs(dt).format("YYYY-MM-DD HH:mm:ss");
};
export const serverDt = (dt) => {
  if (!dt) return "";
  return dayjs(dt).format("YYYY-MM-DDTHH:mm:ss");
};
export const isSameCoord = (a, b, tol = 1e-6) => {
  return Math.abs(a[0] - b[0]) < tol && Math.abs(a[1] - b[1]) < tol;
};
export const arrDepth = (arr) => {
  if (!Array.isArray(arr)) return 0;
  let depth = 1;
  for (let i = 0; i < arr.length; i++) {
    const currentDepth = arrDepth(arr[i]);
    depth = Math.max(depth, currentDepth + 1);
  }
  return depth;
};
export const flattenTree = (nodes, parentNm = null, depth = 0) => {
  let flatArray = [];
  nodes.forEach((node) => {
    flatArray.push({ ...node, depth, parentNm });
    if (node.children && node.children.length > 0) {
      flatArray = flatArray.concat(
        flattenTree(node.children, node.name, depth + 1),
      );
    }
  });
  return flatArray;
};
export const hasIncompleteKor = (str) => {
  for (let char of str) {
    const code = char.charCodeAt(0);
    // 초성(ㄱ~ㅎ): U+3131 ~ U+314E
    // 중성/기타(ㅏ~ㅣ 등): U+314F ~ U+3163
    if (
      (code >= 0x3131 && code <= 0x314e) ||
      (code >= 0x314f && code <= 0x3163)
    ) {
      return true; // 불완전한 한글 있음
    }
  }
  return false; // 모두 완성형 또는 비한글
};
export const loadScript = (src, onSucc = () => {}) => {
  // 스크립트가 이미 로드되었는지 확인
  if (document.querySelector(`script[src="${src}"]`)) {
    console.log("스크립트가 이미 로드되었습니다.");
    return;
  }

  const script = document.createElement("script");
  script.src = src;
  script.async = true;
  script.onload = () => {
    onSucc();
    console.log("스크립트 로딩 완료!");
  };
  script.onerror = (err) => {
    console.error(err, "스크립트 로딩 실패");
  };
  document.body.appendChild(script);
};

export const removeScript = (src) => {
  const script = document.querySelector(`script[src="${src}"]`);
  if (script) {
    document.body.removeChild(script);
  }
};
export const equals = (a, b, precision = 4) => {
  const factor = Math.pow(10, precision);
  return Math.round(a * factor) === Math.round(b * factor);
};
export const reOrder = (arr, obj, idx) => {
  const oidx = arr.indexOf(obj);
  if (idx == "top") idx = 0;
  if (idx == "bottom") idx = arr.length;
  if (idx == "up") idx = oidx - 1;
  if (idx == "down") idx = oidx + 1;
  if (oidx < 0 || oidx === idx || idx < 0) return arr;
  arr.splice(oidx, 1);
  arr.splice(idx, 0, obj);
  return arr;
};
export const qsel = (obj, sel) => {
  if (sel == null) {
    sel = obj;
    obj = document;
  }
  return document.querySelector(sel);
};
export const qsela = (obj, sel) => {
  if (sel == null) {
    sel = obj;
    obj = document;
  }
  return document.querySelectorAll(sel);
};
export const closest = (elem, selector) => {
  while (elem) {
    if (elem.matches(selector)) return elem;
    elem = elem.parentElement;
  }
  return null;
};
export const syncScroll = (source, target) => {
  if (source.dataset.syncing === "true" || target.dataset.syncing === "true")
    return;
  source.dataset.syncing = "true";
  target.dataset.syncing = "true";
  target.scrollTop = source.scrollTop;
  target.scrollLeft = source.scrollLeft;
  requestAnimationFrame(() => {
    source.dataset.syncing = "false";
    target.dataset.syncing = "false";
  });
};
export const innerHtml = (sel) => qsel(sel)?.innerHTML;
export const innerText = (sel) => {
  const rslt = qsel(sel)?.innerText;
  return rslt ? rslt.trim() : "";
};
export const htmlToTxt = (html) => {
  if (!html) return "";
  const dv = document.createElement("div");
  dv.innerHTML = html;
  const rslt = dv.innerText;
  dv.remove();
  return rslt;
};
export const isImgFile = (nm) =>
  [".jpg", ".png", ".jpeg", ".gif", ".bmp"].some((ext) =>
    nm.toLowerCase().endsWith(ext),
  );
export const ensureElement = (sel, callback) => {
  setTimeout(() => {
    if (qsel(sel)) callback();
    else ensureElement(sel, callback);
  }, 10);
};
export const ensureRef = (ref, callback) => {
  setTimeout(() => {
    if (ref.value) callback(ref.value);
    else ensureRef(ref, callback);
  }, 10);
};
export const ensureMeta = (meta, key, callback) => {
  setTimeout(() => {
    if (meta[key]) callback(meta[key]);
    else ensureMeta(meta, key, callback);
  }, 10);
};
export const selectText = (sel) => {
  const element = qsel(sel);
  const range = document.createRange();
  const selection = window.getSelection();
  range.selectNodeContents(element);
  selection.removeAllRanges();
  selection.addRange(range);
};
export const elementExist = (sel) => qsel(sel) != null;
export const isImage = (fn) => {
  const validExtensions = [
    ".jpg",
    ".jpeg",
    ".png",
    ".gif",
    ".webp",
    ".bmp",
    ".svg",
  ];
  const fileExtension = fn.toLowerCase().slice(-5);
  return validExtensions.some((ext) => fileExtension.endsWith(ext));
};
export const fnFromUrl = (url) => {
  const regex = /\/([^\/?#]+)[^/]*$/;
  const match = url.match(regex);
  return match ? match[1] : null;
};
export const valFromObjInArr = (arr, key, val, returnkey, defaultval) => {
  let rslt = arr.find((item) => item[key] == val);
  if (rslt) rslt = rslt[returnkey];
  return rslt ? rslt : defaultval;
};
export const commaFormat = (num) => {
  const parsed = Number(num);
  if (isNaN(parsed)) return "NaN"; // 또는 '', 또는 원본 반환 등 상황에 맞게 처리
  const formatter = new Intl.NumberFormat("en-US");
  return formatter.format(parsed);
};
export function getTimezoneOffsetString(date = new Date()) {
  const offsetMin = date.getTimezoneOffset();
  const sign = offsetMin <= 0 ? "+" : "-";
  const absMin = Math.abs(offsetMin);

  const hours = String(Math.floor(absMin / 60)).padStart(2, "0");
  const minutes = String(absMin % 60).padStart(2, "0");

  return `${sign}${hours}:${minutes}`;
}
export const edgeFromDtRange = (range) => {
  const offsetMin = new Date().getTimezoneOffset();
  let dtst = dayjs(range[0]).add(offsetMin, "m").format("YYYY-MM-DDT00:00:00");
  let dted = dayjs(_.last(range)).add(offsetMin, "m");
  dted = dayjs(dted.format("YYYY-MM-DD"))
    .add(1, "days")
    .format("YYYY-MM-DDT00:00:00");
  return { dtst: dtst, dted: dted };
};
export const strToXml = (xmlStr) => {
  const parser = new DOMParser();
  return parser.parseFromString(xmlStr, "text/xml");
};
export const xmlToStr = (xml) => {
  let xmlString = new XMLSerializer().serializeToString(xml);
  xmlString = xmlString.replace(/>\s+</g, "><");
  xmlString = xmlString.replaceAll('xmlns=""', "");
  return xmlString;
};
export const senitizeFileName = (fn) =>
  fn.replaceAll(" ", "_").replace(/[\\\/:*?"<>|]/g, "");
export const initUrl = (url) => {
  const cleanedBase = config.backend.replace(/\/+$/, "");
  const cleanedPath = url.replace(/^\/+/, "");
  return `${cleanedBase}/${cleanedPath}`;
};
export const openWin = (url) => {
  window.newwin = window.open(url, "_blank");
  // const navigated=evt=>{
  //   if(evt.destination.url.endsWith('/map')){
  //     window.newwin.navigation.removeEventListener("navigate",navigated)
  //     window.newwin.location.href=url
  //   }
  // }
  // window.newwin.navigation.addEventListener("navigate",navigated)
};
function reqConf(method, data, acceptType) {
  const conf = {
    method: method,
    headers: { "Content-Type": "application/json", Accept: acceptType },
    mode: "cors",
  };
  const memStore = useMemberStore();
  if (memStore.isLoggedIn()) conf.headers.Authorization = memStore.bearertoken;
  if (data) {
    if (typeof data === "string") conf.body = data;
    else conf.body = JSON.stringify(data);
  }
  return conf;
}
export const postMultipart = async (url, data, callback) => {
  const fd = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value instanceof Array) value.forEach((val) => fd.append(key, val));
    else fd.append(key, value);
  });
  const conf = reqConf("post");
  delete conf.headers["Content-Type"];
  conf.headers["Accept"] = "application/json";
  conf.body = fd;
  let res = await fetch(initUrl(url), conf);
  if (res.status == 500)
    return { isSuccess: false, status: "error", statusCode: 500 };
  res = await res.json();
  if (callback) callback(res);
  if (res.statusCodeValue == 401) window.location.href = config.frontRoot;
  return res;
};
export const postMultipartXhr = (url, data, onProgress, callback) => {
  const fd = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value instanceof Array) value.forEach((val) => fd.append(key, val));
    else fd.append(key, value);
  });
  const xhr = new XMLHttpRequest();
  xhr.open("POST", initUrl(url), true);
  const memStore = useMemberStore();
  if (memStore.isLoggedIn()) {
    xhr.setRequestHeader("Authorization", memStore.bearertoken);
  }
  xhr.setRequestHeader("Accept", "application/json");
  let lastLoaded = 0;
  let lastTime = Date.now();
  xhr.upload.addEventListener("progress", (e) => {
    if (e.lengthComputable && onProgress) {
      const now = Date.now();
      const timeDiff = (now - lastTime) / 1000;
      const loadedDiff = e.loaded - lastLoaded;
      const speed = timeDiff > 0 ? loadedDiff / timeDiff : 0;
      const percent = (e.loaded / e.total) * 100;
      onProgress({
        speedBytesPerSec: speed,
        loadedBytes: e.loaded,
        totalBytes: e.total,
        percent: percent,
      });
      lastLoaded = e.loaded;
      lastTime = now;
    }
  });
  const promise = new Promise((resolve, reject) => {
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        try {
          const json = JSON.parse(xhr.responseText);
          if (callback) callback(json);
          resolve(json);
        } catch (err) {
          reject(err);
        }
      }
    };
    xhr.onerror = function () {
      reject(new Error("Upload failed"));
    };
  });

  xhr.send(fd);

  // xhr와 promise 모두 반환
  return { xhr, promise };
};
export const down = ({ url, data, fn, method = "post" }) => {
  fetch(initUrl(url), reqConf(method, data, "application/octet-stream")).then(
    (res) => {
      const contentDisposition = res.headers.get("Content-Disposition");
      if (_.isEmpty(fn))
        fn =
          contentDisposition && contentDisposition.indexOf("filename=") !== -1
            ? contentDisposition.split("filename=")[1].replace(/"/g, "").trim()
            : fn;
      if (_.isEmpty(fn)) fn = fnFromUrl(url);
      fn = window.decodeURIComponent(fn);
      res.blob().then((blob) => {
        const a = document.createElement("a");
        const downloadUrl = window.URL.createObjectURL(blob);
        a.href = downloadUrl;
        a.download = fn;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        a.remove();
      });
    },
  );
};
export const loadAuthImg = async (url) => {
  const res = await fetch(
    initUrl(url),
    reqConf("get", null, "application/octet-stream"),
  );
  const blob = await res.blob();
  return URL.createObjectURL(blob);
};
export const fetchImgData = async (url, data, method = "post") => {
  if (!/^https?:/.test(url)) {
    url = initUrl(url);
  }
  const res = await fetch(
    url,
    reqConf(method, data, "application/octet-stream"),
  );
  const blob = await res.blob();
  return URL.createObjectURL(blob);
};
export const plainReq = async ({ url, pms, callback, method, body }) => {
  url += _.isEmpty(pms) ? "" : "?" + new URLSearchParams(pms).toString();
  // console.log('plainReq',url)
  if (!callback) callback = () => {};
  const opt = {
    method: method, // *GET, POST, PUT, DELETE 등
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
  };
  if (body) opt.body = JSON.stringify(body);
  const res = await fetch(url, opt);
  const json = await res.json();
  callback(json);
  return json;
};
export const plainGet = ({ url, pms, callback }) =>
  plainReq({ url: url, pms: pms, callback: callback, method: "GET" });
export const plainPost = ({ url, body, callback }) =>
  plainReq({ url: url, body: body, callback: callback, method: "POST" });
export const req = async (
  url,
  method = "get",
  pms = {},
  data = {},
  callback = () => {},
  onerr = () => {},
) => {
  url = initUrl(url);
  url += _.isEmpty(pms) ? "" : "?" + new URLSearchParams(pms).toString();
  // console.log('req',url)
  const conf = reqConf(method, data, "application/json");
  const metaStore = useMetaStore();
  metaStore.onServerRequest = true;
  if (!callback) callback = data;
  if (!callback) callback = () => {};
  const res = await fetch(url, conf);
  let json = { isSuccess: false, status: "fail", statusCode: 500 };
  try {
    json = await res.json();
  } catch (e) {}
  if (!res.ok) {
    if (res.status == 401 || res.status == 403) {
      const memStore = useMemberStore();
      const router = useRouter();
      memStore.reset();
      metaStore.toastKey(
        res.status == 401 ? "signinisrequired" : "no_permission",
      );
      if (router) {
        router.push(res.status == 401 ? config.frontRoot + "login" : "/");
      } else {
        window.location.href =
          res.status == 401 ? config.frontRoot + "login" : "/";
      }
      return;
    } else onerr(json);
  }
  metaStore.onServerRequest = false;
  if (json.isSuccess == null) json.isSuccess = res.ok;
  callback(json);
  return json;
};
export const get = (url, callback = () => {}, pms, onerr = () => {}) =>
  req(url, "get", pms, null, callback, onerr);
export const gets = async ({
  urls = [],
  pmss = [],
  callback = () => {},
  onerr = () => {},
}) => {
  const promises = urls.map((url, idx) =>
    get(url, undefined, pmss[idx])
      .then((res) => ({ res, err: null }))
      .catch((err) => ({ res: null, err })),
  );
  const settled = await Promise.all(promises);
  const results = settled.map((r) => r.res);
  results.forEach((res, idx) => {
    try {
      if (pmss && pmss[idx]) res.pms = pmss[idx];
    } catch (e) {}
  });
  const errs = settled.map((r) => r.err);
  if (
    results &&
    results.length &&
    results[0] &&
    !results[0].isSuccess &&
    results[0].statusCode == 401 &&
    results[0].statusCode == 403
  ) {
    const res = results[0];
    const metaStore = useMetaStore();
    const memStore = useMemberStore();
    const router = useRouter();
    memStore.reset();
    metaStore.toastKey(
      res.statusCode == 401 ? "signinisrequired" : "no_permission",
    );
    if (router) {
      router.push(res.statusCode == 401 ? config.frontRoot + "login" : "/");
    } else {
      window.location.href =
        res.statusCode == 401 ? config.frontRoot + "login" : "/";
    }
    return;
  }
  if (callback) callback(results);
  if (onerr) onerr(errs);
  return results;
};
export const post = (url, data, callback = () => {}, onerr = () => {}) =>
  req(url, "post", null, data, callback, onerr);
export const postWithQuery = (
  url,
  pms,
  data,
  callback = () => {},
  onerr = () => {},
) => req(url, "post", pms, data, callback, onerr);
export const toJson = (val) =>
  _.isString(val) ? JSON.parse(val) : JSON.parse(JSON.stringify(val));
export const loadEpsgs = (callback) =>
  get("rest/public/epsgsinconf", (res) => {
    try {
      const epsgs = res.data.map((conf) => conf.ival);
      if (!epsgs.includes(900913)) epsgs.unshift(900913);
      if (!epsgs.includes(3857)) epsgs.unshift(3857);
      if (!epsgs.includes(4326)) epsgs.unshift(4326);
      callback(epsgs);
      return;
    } catch (e) {}
    try {
      callback([]);
    } catch (e) {}
  });
export const loadEpsgsWithPrjInit = async (callback) => {
  let epsgs = [];
  if (!proj4.defs("EPSG:5181")) {
    const res = await get("rest/public/epsgsinconf");
    try {
      epsgs = res.data.map((conf) => conf.ival);
      if (!epsgs.includes(900913)) epsgs.unshift(900913);
      if (!epsgs.includes(3857)) epsgs.unshift(3857);
      if (!epsgs.includes(4326)) epsgs.unshift(4326);
      const epsgdefs = await get("rest/public/proj4defs/" + epsgs.toString());
      if (epsgdefs.data) {
        _.entries(epsgdefs.data).forEach(([key, val]) => {
          if (!proj4.defs(key)) proj4.defs(key, val);
        });
        if (!proj4.defs("EPSG:5181"))
          proj4.defs(
            "EPSG:5181",
            "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +units=m +no_defs",
          );
        register(proj4);
      }
    } catch (e) {}
  } else {
    epsgs = Object.keys(proj4.defs).filter((key) => key.startsWith("EPSG:"));
  }
  try {
    callback(epsgs);
  } catch (e) {}
  return epsgs;
};
export const isDummyBbox = (bbox) => {
  if (!bbox) return true;
  const [minx, miny, maxx, maxy] = bbox;
  return (
    (minx === 0 && miny === 0 && maxx === 0 && maxy === 0) ||
    bbox.toString() ==
      "-112319.52429722421,-112325.29199212017,-111319.49079327358,-111325.14286638453"
  );
};
export const senitizeLonLatBbox = (minx, miny, maxx, maxy) => {
  // 문자열이면 숫자로 변환
  minx = parseFloat(minx);
  miny = parseFloat(miny);
  maxx = parseFloat(maxx);
  maxy = parseFloat(maxy);

  // 위도 1km → 도 단위
  const kmToLat = 1 / 111.32;

  // 경도 1km → 도 단위 (중간 위도 기준)
  const midLat = (miny + maxy) / 2;
  const kmToLon = 1 / (111.32 * Math.cos((midLat * Math.PI) / 180));

  // min/max가 0이면 보정
  const newMinX = minx === 0 ? maxx - kmToLon : minx;
  const newMaxX = maxx === 0 ? minx + kmToLon : maxx;
  const newMinY = miny === 0 ? maxy - kmToLat : miny;
  const newMaxY = maxy === 0 ? miny + kmToLat : maxy;

  return [newMinX, newMinY, newMaxX, newMaxY];
};
export const naverLayer = (basesrc, ext, query) => {
  return new TileLayer({
    source: new XYZ({
      url: basesrc + "{z}/{x}/{y}." + ext + "?" + query,
      maxZoom: 20,
      tileLoadFunction: function (imageTile, src) {
        // let newsrc =
        //   config.backend + "proxy/cache?url=" + encodeURIComponent(src);
        // imageTile.getImage().src = newsrc;
        imageTile.getImage().src = src;
        // imageTile.getImage().osrc = src;
        // imageTile.getImage().crossOrigin = "anonymous";
        // imageTile.getImage().onerror = function () {
        //   if (this.processError || this.success || this.retry > 3) return;
        //   this.processError = true;
        //   setTimeout(() => {
        //     if (this.processError || this.success || this.retry > 3) return;
        //     let osrc = this.osrc;
        //     if (!this.retry) this.retry = 0;
        //     this.retry++;
        //     let rsrc =
        //       config.backend +
        //       "proxy/cache?url=" +
        //       encodeURIComponent(osrc + "&at=" + this.retry);
        //     // rsrc = config.backend+'proxy/get?url='+encodeURIComponent(osrc+'&at='+this.retry);
        //     console.warn("Tile load error, retrying...", rsrc);
        //     this.src = rsrc;
        //     this.processError = false;
        //   }, 1000);
        // };
        // imageTile.getImage().onload = function () {
        //   this.success = true;
        // };
      },
    }),
    extent: config.KoreaBbox3857,
  });
};
export const kakaoLayer = (map, basesrc, ext) => {
  const kakaoproj = new Projection({
    code: "EPSG:5181",
    extent: [
      -30000 - 524288,
      -60000 - 524288,
      494288 + 524288,
      988576 + 524288,
    ],
  });
  const kakaotilegrid = new TileGrid({
    extent: kakaoproj.getExtent(),
    tileSize: 256,
    resolutions: [
      4096, 2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25,
    ],
    minZoom: 1,
  });
  return new TileLayer({
    extent: config.KoreaBbox3857,
    source: new XYZ({
      projection: kakaoproj,
      tileGrid: kakaotilegrid,
      tileUrlFunction: (tileCoord) => {
        const zoom = map.getView().getZoom();
        let sVal = kakaotilegrid.getTileCoordResolution(tileCoord);
        let yLength = 988576 - -60000 + 524288 + 524288;
        let yTile = yLength / (sVal * kakaotilegrid.getTileSize(zoom));
        let tileGap = Math.pow(2, tileCoord[0] - 1);
        yTile = yTile - tileGap - 1;
        let xTile = tileCoord[1] - tileGap;
        const zTile = 15 - tileCoord[0];
        yTile = yTile - tileCoord[2];
        let url = basesrc + `${zTile}/${yTile}/${xTile}.${ext}`;
        return url;
      },
    }),
  });
};
export const addIfr = (id, src) => {
  if (qsel("#" + id)) document.getElementById(id).remove();
  const iframe = document.createElement("iframe");
  iframe.src = src;
  iframe.width = "1";
  iframe.height = "1";
  iframe.style.border = "0";
  iframe.style.position = "absolute";
  iframe.style.top = "0";
  iframe.style.right = "0";
  iframe.id = id;
  document.body.appendChild(iframe);
};
